import { Home } from "@/views";
import authRoutes from "./auth/routes";
import userRoutes from "./user/routes";
import conciergeRoutes from "./concierge/routes";
import adminRoutes from "./admin/routes";
import superadminRoutes from "./superadmin/routes";

export default [
  {
    path: "/",
    name: "home",
    component: Home
    // children: authRoutes
  },
  ...authRoutes,
  ...userRoutes,
  ...conciergeRoutes,
  ...adminRoutes,
  ...superadminRoutes
];
